<template>
	<div class="login-page">
		<div class="form">
			<form @submit.prevent="validateBeforeSubmit">

				<b-form-group label-size="1" :state="errors.first('username') ? false : true" :invalid-feedback="errors.first('username')" label="Usuario" label-for="username">
					<b-form-input @keyup.enter.native="validateBeforeSubmit" :state="errors.first('username') ? false : null" v-validate="'required'" v-model="username" id="username" name="username" type="text"></b-form-input>
				</b-form-group>

				<b-form-group :state="errors.first('password') ? false : true" :invalid-feedback="errors.first('password')" label="Contraseña" label-for="password">
					<b-form-input @keyup.enter.native="validateBeforeSubmit" :state="errors.first('password') ? false : null" v-validate="'required'" v-model="password" id="password" name="password" type="password"></b-form-input>
				</b-form-group>

				<span class="text-danger" v-show="this.errorMessage">{{ this.errorMessage }}</span><br>
				<b-button :disabled="submitted" variant="secondary" class="cursor-pointer" @click="validateBeforeSubmit">Ingresar</b-button>
			</form>
		</div>
	</div>
</template>

<script>
import Auth from '../services/Auth';
import Vue from 'vue';

export default {
	data: function () {
		return {
			username: '',
			password: '',
			errorMessage: null,
			submitted: false
		};
	},
	methods: {
		validateBeforeSubmit: async function ()	{
			try {
				this.errorMessage = null;
				let validationResult = await this.$validator.validateAll();
				if (validationResult) {
					this.submitted = true;
					await Auth.authenticate({
						username: this.username,
						password: this.password
					});
					this.$router.push(this.$router.currentRoute.query.redirect || '/calls');
				}
			} catch (error) {
				if (error.response && error.response.data) console.log(error.response.data.message);
				this.submitted = false;
				if (error.response && error.response.data) {
					if (error.response.data.message == 'INVALID_SITUATION') this.errorMessage = 'La situación del usuario es inválida';
					else if (error.response.data.message == 'INVALID_STATUS') this.errorMessage = 'El estado del usuario es inválido';
					else if (error.response.data.message == 'INACTIVE_USER') this.errorMessage = 'El usuario está inactivo';
					else if (error.response.data.message == 'INVALID_USERNAME') this.errorMessage = 'El usuario es inválido o no existe';
					else if (error.response.data.message == 'NOT_FOUND') this.errorMessage = 'El usuario es inválido o no existe';
					else if (error.response.data.message == 'WRONG_PASSWORD') this.errorMessage = 'La contraseña es incorrecta';
					else this.errorMessage = error.toString();
				} else this.errorMessage = error.toString();
			}
		}
	}
};
</script>

<style scoped>
	.login-page {
		width: 20rem;
		height: 10rem;
		position: absolute;
		top: calc(50% - 5rem);
		left: calc(50% - 10rem);
	}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue